import { AlertCircle } from 'lucide-react'
import { cn } from '~/lib/utils'
import Card from '~/components/convenience/GlassCard'
import { i18n } from '@lingui/core'

type FormErrorSummaryProps = {
  errorsWithSections: Map<string, string>
  onSectionClick?: (identifier: string) => void
  scrollToElement?: (identifier: string) => void
}

export const FormErrorSummary = ({
  errorsWithSections,
  onSectionClick,
  scrollToElement,
}: FormErrorSummaryProps) => {
  if (errorsWithSections.size === 0) {
    return null
  }

  const sectionNames = Array.from(errorsWithSections.entries()).map(([id, name]) => ({
    id,
    name,
  }))

  if (sectionNames.length === 0) {
    return null
  }

  const handleSectionClick = (identifier: string) => {
    if (onSectionClick) {
      onSectionClick(identifier)
    }

    if (scrollToElement) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          scrollToElement(identifier)
        })
      })
    }
  }

  return (
    <Card className={cn('p-2 lg:px-6 lg:py-4 mb-6 border-2 border-red-200')}>
      <div className="flex items-start gap-3">
        <AlertCircle className="h-5 w-5 text-red-500 shrink-0 mt-0.5" aria-hidden="true" />
        <div className="flex-1">
          <p className="text-sm font-medium text-heading mb-2">
            {i18n._('Bitte korrigieren Sie die folgenden Bereiche:')}
          </p>
          <div className="flex flex-wrap gap-x-2 gap-y-1">
            {sectionNames.map(({ id, name }, index) => (
              <span key={id}>
                <button
                  type="button"
                  onClick={() => handleSectionClick(id)}
                  className="text-sm text-body hover:text-heading hover:underline cursor-pointer transition-colors"
                >
                  {name}
                </button>
                {index < sectionNames.length - 1 && <span className="text-secondary">,</span>}
              </span>
            ))}
          </div>
        </div>
      </div>
    </Card>
  )
}
